import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

type ParamsType = {
  roomId: string
}

// 直播間的相關資料，例如 kol 名稱、觀看數、跑馬燈或公告等
class FetchRoomDataApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_ROOM_DATA'

    this.config = {
      url: `/v1/room/id`,
      method: 'GET',
      params,
    }
  }
}

export const fetchRoomData = (params: ParamsType) => getCallApiFunction(new FetchRoomDataApi(params))
